import React, { PropTypes } from 'react';
import PureComponent from 'components/PureComponent';
import { Link } from 'react-router';
import cookie from 'react-cookies';
import fetch from 'node-fetch';

class BuyButton extends React.Component {
  constructor() {
    super();
    this.state = {};

    this.getCityLink = this.getCityLink.bind(this);
  }

  static propTypes = {
    isSimple: PropTypes.bool
  };

  static defaultProps = {
    isSimple: false
  };

  componentDidMount() {
    fetch('/files/cities.json')
      .then(r => r.json())
      .then(data => {
        this.setState({ defaultLink: data.defaultLink });
      })
      .catch(err => {
        console.log('Error: ' + err.message);
      });
  }

  getCityLink() {
    var link = cookie.load('link');

    if (!link) {
      link = this.state.defaultLink;
    }

    return link;
  }

  render() {
    require('./BuyButton.styl');

    const cityLink = this.getCityLink();

    return (
      <a
        href={cityLink}
        target={'_blank'}
        className={this.props.isSimple ? `Button` : `BuyButton`}
        {...this.props}
      >
        <span>Купить</span>
        <i className="BuyButton__i"></i>
      </a>
    );
  }
}

export default BuyButton;



// WEBPACK FOOTER //
// ./src/components/BuyButton/BuyButton.js